import React from 'react';
import './MakeTheCircles.css'; // Ensure this path is correct

const MakeTheCircles = () => {
  return (
    <div className='page'>
      <div className="header">
        <h1>Trinox</h1>
      </div>

      <div className="wheels-container">
        <div className="wheel left">
          <img src="https://trinoxabrasives.com/static/images/3_Fr.png" alt="Orange and black abrasive wheel" loading="lazy" />
        </div>
        <div className="wheel center-back">
          <img src="https://trinoxabrasives.com/static/images/5_Single.png" alt="Grey abrasive wheel, rear center" loading="lazy" />
        </div>
        <div className="wheel right">
          <img src="https://trinoxabrasives.com/static/images/Single_3.png" alt="Dark grey abrasive wheel" loading="lazy" />
        </div>
        <div className="wheel center-front left">
          <img src="https://trinoxabrasives.com/static/images/1_copy_Single.png" alt="Light grey abrasive wheel, front left" loading="lazy" />
        </div>
        <div className="wheel center-front right">
          <img src="https://trinoxabrasives.com/static/images/Tri_1-02.png" alt="Segmented abrasive wheel, front right" loading="lazy" />
        </div>
      </div>

      <div className="title-abrasive">
        <h2 className='abrasive' style={{ color: 'red' , fontSize: '30px', fontWeight: '800'}}>ABRASIVE PRODUCT</h2>
        <h2 className='catalog' style={{ fontSize: '30px', fontWeight: '800'}}>CATALOG</h2>
        <div className='line'></div>
      </div>
    </div>
  );
};

export default MakeTheCircles;

